import {Injectable} from '@angular/core';
import {Router, UrlTree} from '@angular/router';
import {catchError, defaultIfEmpty, map, Observable, of, take, timeout} from 'rxjs';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {AccountRole} from '@enums/AccountRole';
import {buildPath} from '@utils/util-builder';

@Injectable({providedIn: 'root'})
export class KpiEntryGuard {
    constructor(private readonly _http: HttpClient, private readonly _router: Router) {}

    canActivate(): Observable<boolean | UrlTree> {
        const denied = this._router.parseUrl('/404-not-found');
        return this._http.get<{rol?: unknown} | null>(buildPath(['data-core/Account/getAccount'])).pipe(
            take(1),
            timeout(5000),
            map((account): boolean | UrlTree => {
                if (account == null) return this._router.parseUrl('/sign-in');

                // Use the server account, not browser-cached user state, for landing decisions.
                switch (account.rol) {
                    case AccountRole.master:
                    case AccountRole.semiMaster:
                        return true;
                    case AccountRole.adminHotel:
                    case AccountRole.accountant:
                        return this._router.parseUrl('/hotels/users');
                    case AccountRole.provider:
                        return this._router.parseUrl('/providers/hotels');
                    default:
                        return denied;
                }
            }),
            defaultIfEmpty(denied),
            catchError((error: unknown) => of(error instanceof HttpErrorResponse && error.status === 401
                ? this._router.parseUrl('/sign-in') : denied))
        );
    }
}
